exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".digi-kalk .info-over-cards{width:90%;padding:30px 30px 10px;margin-bottom:20px;border-bottom:2px dashed #f35900}.digi-kalk .card{width:90%;height:100px;background-color:#fafafa;box-shadow:0 2px 12px 0 rgba(0,0,0,.1);display:flex;align-items:center;margin-bottom:10px;padding-right:15px}.digi-kalk .card p{margin:0}.digi-kalk .card-icons{display:flex;flex-direction:column;padding:0 20px}.mobile .info-over-cards{padding:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5ddfb92a","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Report.vue
// module id = 51
// module chunks = 0